import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import PropTypes from 'prop-types'
import Dolphin from '../svg/dolphin'
import MineralSwim from '../svg/mineralSwim'
import OzoneSwim from '../svg/ozoneSwim'
import EcoSwim from '../svg/eco-swim'
import { BLOCKS } from '@contentful/rich-text-types'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { Triangle } from 'react-feather'
import Mline from '../svg/m-line'
import Sline from '../svg/s-line'
import Xline from '../svg/x-line'
import Eline from '../svg/e-line'
import Fusionline from '../svg/fusion-line'
import O3 from '../svg/o3-line'
import Wave from '../svg/wave'
import Swash from '../svg/swash-line'
import Liberty from '../svg/liberty-line'
import OzoneSwimLine from '../svg/ozone-swim-line'
import EcoSwimLine from '../svg/eco-swim-line'
import SkimmiLine from '../svg/skimmi-line'
import EonLine from '../svg/eon-line'

import {
	DolphinBanner,
	DolphinBannerContainer,
	BannerTextHolder,
	FullSectionCol,
	DolphinSeries,
	BannerText,
	SeriesItemsContainer,
	NoItems,
	ItemContainer,
	SeriesItemImage,
	ItemLink,
	ItemTtl,
	CompareModels,
} from './styles'

const SeriesItems = graphql`
	query SeriesItemsQuery {
		seriesData: allContentfulProduct {
			edges {
				node {
					series
					model
					slug
					node_locale
					brand
					countryAvailability
					categories {
						slug
					}
					images {
						fluid(quality: 60, maxWidth: 300, maxHeight: 300) {
							src
							srcWebp
						}
					}
				}
			}
		}
	}
`

const Series = ({
	series,
	locale,
	seriesPageDetails,
	brandPage,
	xlarge,
	large,
	medium,
	small,
	xsmall,
	xxsmall,
	slug,
	checkedLocale,
}) => {
	const SeriesItemsQuery = useStaticQuery(SeriesItems)
	const {
		seriesData: { edges: edgeArray },
	} = SeriesItemsQuery
	const products = edgeArray
		.filter((product, i) => {
			const availability = product.node.countryAvailability
			const alterLocale = product.node.node_locale.split('-')
			const splitLocale = alterLocale[1]
			const x = availability.indexOf(splitLocale)
			if (x >= 0) {
				return (
					product.node.series === series &&
					product.node.node_locale === locale &&
					product.node.slug != slug
				)
			}
		})
		.filter(product =>
			product.node.categories === null
				? product
				: product.node.categories?.slug != 'spare-parts'
		)
		.filter(product => product.node.slug !== 'dolphin-s-100-bonus')
	// console.log(seriesPageDetails)
	// console.log(brandPage)
	const { banner } = seriesPageDetails != null ? seriesPageDetails : ''
	const { backgroundImage } =
		seriesPageDetails != null
			? series === 'Ozone Swim Line'
				? seriesPageDetails.banner
				: seriesPageDetails
			: ''

	const checkBg = el => {
		return series === 'Ozone Swim Line' ? el.banner : el
	}
	const sources = backgroundImage
		? [
				{
					...backgroundImage.fluid,
					srcSet: `${backgroundImage.fluid.src} 1920w`,
					srcSetWebp: `${backgroundImage.fluid.srcWebp} 1920w`,
					media: `(min-width: 1601px)`,
				},
				{
					...checkBg(xlarge).backgroundImage.fluid,
					srcSet: `${checkBg(xlarge).backgroundImage.fluid.src} 1699w`,
					srcSetWebp: `${checkBg(xlarge).backgroundImage.fluid.srcWebp} 1024w`,
					media: `(min-width: 1400px) and (max-width: 1699px)`,
				},
				{
					...checkBg(large).backgroundImage.fluid,
					srcSet: `${checkBg(large).backgroundImage.fluid.src} 1399w`,
					srcSetWebp: `${checkBg(large).backgroundImage.fluid.srcWebp} 1399w`,
					media: `(min-width: 1280px) and (max-width: 1399px)`,
				},
				{
					...checkBg(medium).backgroundImage.fluid,
					srcSet: `${checkBg(medium).backgroundImage.fluid.src} 1279w`,
					srcSetWebp: `${checkBg(medium).backgroundImage.fluid.srcWebp} 1279w`,
					media: `(min-width: 1024px) and (max-width: 1279px)`,
				},
				{
					...checkBg(small).backgroundImage.fluid,
					srcSet: `${checkBg(small).backgroundImage.fluid.src} 1023w`,
					srcSetWebp: `${checkBg(small).backgroundImage.fluid.srcWebp} 1023w`,
					media: `(min-width: 768px) and (max-width: 1023px)`,
				},
				{
					...checkBg(xsmall).backgroundImage.fluid,
					srcSet: `${checkBg(xsmall).backgroundImage.fluid.src} 767w`,
					srcSetWebp: `${checkBg(xsmall).backgroundImage.fluid.srcWebp} 767w`,
					media: `(min-width: 525px) and (max-width: 767px)`,
				},
				{
					...checkBg(xxsmall).backgroundImage.fluid,
					srcSet: `${checkBg(xxsmall).backgroundImage.fluid.src} 524w`,
					srcSetWebp: `${checkBg(xxsmall).backgroundImage.fluid.srcWebp} 524w`,
					media: `(max-width: 524px)`,
				},
		  ]
		: ''
	const options = {
		renderNode: {
			[BLOCKS.HEADING_1]: (node, children) => <></>,
			[BLOCKS.PARAGRAPH]: (node, children) => (
				<BannerText>{children}</BannerText>
			),
		},
	}
	return series ? (
		<FullSectionCol>
			<DolphinBanner sources={sources}>
				<DolphinBannerContainer sources={sources}>
					{
					brandPage.slug === 'dolphin/skimmi-line' ?(
						<SkimmiLine width="250" height="120" />
					) : 
					brandPage.slug === 'dolphin' ? (
						<Dolphin width="250" height="120" />
					) : brandPage.slug === 'mineral-swim' ? (
						<MineralSwim width="350" height="120" />
					) : brandPage.slug === 'ozone-swim' ? (
						<OzoneSwim width="350" height="120" />
					) : brandPage.slug === 'eco-swim' ? (
						<EcoSwim width="350" height="120" />
					) : (
						''
					)}

					<BannerTextHolder>
						<DolphinSeries>
							{/* {
								series === 'Eco Swim' ? (
									<span>Explore</span>
								) : ( */}
							<span>Explore the</span>
							{/* )
							} */}
							{series === 'M Line' ? <Mline /> : ''}
							{series === 'S Line' ? <Sline /> : ''}
							{series === 'X Line' ? <Xline /> : ''}
							{series === 'Fusion Line' ? (
								<Fusionline height="100%" width="100%" />
							) : (
								''
							)}
							{series === 'O₃ Line' ? <O3 /> : ''}
							{series === 'Wave' ? <Wave /> : ''}
							{series === 'Swash Line' ? <Swash /> : ''}
							{series === 'Liberty Line' ? <Liberty /> : ''}
							{series === 'Ozone Swim Line' ? <OzoneSwimLine /> : ''}
							{series === 'Eco Swim' ? <EcoSwimLine /> : ''}
							{series === 'E Line' ? <Eline /> : ''}
							{series === 'Eon Line' ? <EonLine /> : ''}
						</DolphinSeries>
						{banner != null && series != 'Ozone Swim Line' ? (
							documentToReactComponents(banner.description.json, options)
						) : series === 'Ozone Swim Line' ? (
							<BannerText>
								Enjoy an easy and relaxing pool cleaning experience
							</BannerText>
						) : (
							''
						)}
					</BannerTextHolder>
				</DolphinBannerContainer>
			</DolphinBanner>
			<SeriesItemsContainer css={{ margin: products.length < 1 ? '0' : '' }}>
				{products.length < 1 ? (
					<NoItems>There is no other items for this line</NoItems>
				) : (
					products.map((items, i) => {
						const { node: item } = items
						return (
							<ItemContainer key={i}>
								<SeriesItemImage>
									<source
										srcSet={`${item.images[0].fluid.srcWebp} 200w`}
										type="image/webp"
									></source>
									<source srcSet={item.images[0].fluid.src}></source>
									<img
										src={item.images[0].fluid.src}
										alt={`${item.brand} ${item.model}`}
									/>
								</SeriesItemImage>
								{/* <SeriesItemImage
									src={item.images[0].fluid.srcWebp}
									alt={`${item.brand} ${item.model}`}
								></SeriesItemImage> */}
								<ItemLink to={`${checkedLocale}/product/${item.slug}`}>
									<ItemTtl>{item.model}</ItemTtl>
									<Triangle
										fill="#bababa"
										stroke="#bababa"
										height="15"
										width="15"
										viewBox="0 0 30 30"
									/>
								</ItemLink>
							</ItemContainer>
						)
					})
				)}
			</SeriesItemsContainer>
			<CompareModels href={`${checkedLocale}/product-comparison`}>
				{' '}
				Compare Products
			</CompareModels>
		</FullSectionCol>
	) : (
		''
	)
}

export default Series
